import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import './Home.css';

const About = () => {
  return (
    <div className='text-center'>
      <h1 className='logo-text mt-5'>Under construction...</h1>
    </div>
  )
}

export default About